<template>
  <div
    :class="[
      'slide' + (index + 1),
      'slide',
      $vuetify.breakpoint.mdAndUp ? 'desktop-borders' : '',
      $vuetify.breakpoint.mdAndUp ? 'desktop' : 'mobile',
      $vuetify.breakpoint.mdAndUp
        ? 'bkgrd-desktop-slide' + (index + 1)
        : 'bkgrd-mobile-slide' + (index + 1),
    ]"
    :style="{
      opacity
    }"
  >
    <router-link v-if="$vuetify.breakpoint.smAndDown" to="/" style="text-decoration: none;">
        <v-icon class="back-arrow-mobile" large color="#414141">mdi-chevron-left</v-icon>
    </router-link>
    <p v-if="$vuetify.breakpoint.smAndDown" class="mobile-page-title">Portfolio</p>

    <div ref="upperBound" v-if="$vuetify.breakpoint.smAndDown" class="wrappers-on-wrappers" >
      <div class="mobile-work-menu-wrapper">
        <div class="mobile-work-menu">
          <v-btn
            class="slide-buttons"
            v-for="(slide, i) in slideData"
            :key="i"
            v-on:click="$emit('setIndex', i)"
            rounded
            :outlined="!(index === i)"
            :dark="index === i"
            color="#414141"
            >{{ slide.title }}
          </v-btn>
        </div>
      </div>
    </div>
    <h1 v-if="$vuetify.breakpoint.mdAndUp" class="desktop-title" :style="{
      transform: transformTitle,
      opacity: titleOpacity
    }">
      {{ slideData[index].title }}
    </h1>
    <div class="image-wrapper" :style="{
      transform: transformImage,
      opacity: imageOpacity
    }">
        <img
        :src="
            $vuetify.breakpoint.smAndDown
            ? slideData[index].srcMobile
            : slideData[index].src
        "
        :alt="slideData[index].alt"
        :key="slideData[index].title"
        :class="
            $vuetify.breakpoint.mdAndUp
            ? 'img-desktop-slide' + (index + 1)
            : 'img-mobile-slide' + (index + 1)
        "
        />
    </div>
  </div>
</template>

<script>
import workSlideAnimationBus from '../workSlideAnimationBus'
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    mobile: {
      type: Boolean
    }
  },
  computed: {
    transformTitle () { return 'translateY(' + (this.titleTranslate * -100) + 'px)' },
    transformImage () { return 'translateY(' + (this.imageTranslate * 100) + 'px)' }
  },
  data () {
    return {
      opacity: 0,
      titleTranslate: 0,
      titleOpacity: 0,
      imageTranslate: 0,
      imageOpacity: 0,
      slideData: [
        {
          title: 'Interactive',
          src: require('@/assets/slide1-desktop.png'),
          srcMobile: require('@/assets/slide1-mobile.png'),
          alt: 'phone'
        },
        {
          title: 'Non-profits',
          src: require('@/assets/slide2-desktop.png'),
          srcMobile: require('@/assets/slide2-mobile.svg'),
          alt: 'laptop'
        },
        {
          title: 'Educational',
          src: require('@/assets/slide3-desktop.png'),
          srcMobile: require('@/assets/slide3-mobile.svg'),
          alt: 'two phones'
        },
        {
          title: 'Branding',
          src: require('@/assets/slide4-desktop.png'),
          srcMobile: require('@/assets/slide4-mobile.png'),
          alt: 'devices'
        }
      ]
    }
  },
  async mounted () {
    await workSlideAnimationBus.registerComponent('slide', this)
    this.$nextTick(() => {
      if (this.$refs.upperBound) {
        const upperBoundToEnd = window.innerHeight - (this.$refs.upperBound.offsetTop + this.$refs.upperBound.clientHeight)
        document.documentElement.style.setProperty('--upperBoundToEnd', `${upperBoundToEnd}px`)
        window.addEventListener('resize', () => {
          const upperBoundToEnd = window.innerHeight - (this.$refs.upperBound.offsetTop + this.$refs.upperBound.clientHeight)
          document.documentElement.style.setProperty('--upperBoundToEnd', `${upperBoundToEnd}px`)
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.desktop{
  .image-wrapper{
    position: absolute;
    top:0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: clamp(40vw, 1000px, 60vw);
    height: calc(300px + 10vw);
  }
  // &.slide2{
  //   .image-wrapper{
  //     align-items: flex-end;
  //   }
  // }
}
.mobile{
  .image-wrapper{
    // position: absolute;
    display: grid;
    place-items: center;
    // bottom:0;
    width: 100vw;
    height: var(--upperBoundToEnd);
  }
}
h1 {
  position: relative;
  font-size: clamp(2vw, 8vw, 8rem);
  text-align: center;
}
.mobile-page-title{
    // position: absolute;
    // left: calc(6vw + 10px);
    // top: 7vh;
    padding-left: calc(6vw + 10px);
    font-size: calc(5vh + 14px);
    font-weight: 600;
    color: #414141;
}
.back-arrow-mobile{
  padding: calc(6vw + 10px) 0 0 calc(6vw + 10px);
    // position: absolute;
    // left: 5vw;
    // top: 3vh;
}
.desktop-title {
  text-transform: uppercase;
}
.desktop-borders {
  border-radius: 25px;
}
.slide {
  position: relative;
  width: clamp(40vw, 1000px, 60vw);
  height: calc(300px + 10vw);
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.1);
}
.bkgrd-desktop-slide1 {
  background: linear-gradient(105.78deg, #fcbb46 -4.35%, #56377d 105.02%);
}
.bkgrd-mobile-slide1 {
  background: linear-gradient(168.11deg, #fd9e9e -3.59%, #9aa3d5 107.17%);
}
.img-desktop-slide1 {
  top: 6.5vh;
  width: calc(5.5vw + 147px);
  max-width: 400px;
}
.img-mobile-slide1 {
    // position: static;
    height: calc(var(--upperBoundToEnd) * 0.8);
}
// .slide{
//   display: flex;
//   column-gap: 2vw;
//   position: relative;
//   justify-content: center;
// }
.bkgrd-desktop-slide2 {
  background: linear-gradient(105.78deg, #30b4f0 -4.35%, #efd15b 105.02%);
}
.bkgrd-mobile-slide2 {
  background: linear-gradient(167.6deg, #50b9d7 -10.83%, #e0cf67 106.96%);
}
.img-desktop-slide2 {
  bottom: 0;
  width: calc(4vw + 394px);
  max-width: 1000px;
}
.img-mobile-slide2 {
    align-self: center;
    width: calc(81vw + 25px);
}
.bkgrd-desktop-slide3 {
  background: linear-gradient(105.78deg, #eb4e4e 32.7%, #dd6c00 105.02%);
}
.bkgrd-mobile-slide3 {
  background: linear-gradient(166.9deg, #f46e6e -5.98%, #dfa40e 106.97%);
}
.img-desktop-slide3 {
  // width: calc(14vw + 367px);
  width: calc(14vw + 266px);
  // transform: translateX(-60px);
}
.img-mobile-slide3 {
  bottom: 8vh;
  height: calc(var(--upperBoundToEnd) * 0.8);
}
.bkgrd-desktop-slide4 {
  background: linear-gradient(105.78deg, #cb9c57 -7.88%, #82565e 105.02%);
}
.bkgrd-mobile-slide4 {
  background: linear-gradient(167.6deg, #f5aa46 -10.83%, #ba3d46 106.96%);
}
.img-desktop-slide4 {
  top: 4vh;
  width: calc(59vw + 3px);
  max-width: 1000px;
}
.img-mobile-slide4 {
    align-self: center;
    // bottom: 30vh;
    width: calc(99vw);
}
.wrappers-on-wrappers {
  // position: absolute;
  z-index: 10000;
  width: 100vw;
  // top: calc(40px + 12vh);
  .mobile-work-menu {
    display: flex;
    z-index: 10000;
    align-items: center;
    overflow-x: scroll;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    overflow-y: scroll;
    padding: 0 50vw 0 6vw;

    .slide-buttons {
      margin: 0 10px;
      padding: 3vw 7vw;
      text-transform: capitalize;
      font-size: 3.5vw;
      letter-spacing: -0.035em;
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
    }
  }
  .mobile-work-menu::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  .mobile-work-menu-wrapper {
    overflow: hidden;
  }
}
</style>
